import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { useDispatch, useSelector } from "react-redux";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";
import Loader from "../Loader";
import { toast } from "react-toastify";
import logo from "../../assets/rankers.jpg";


function Signup() { 
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

const userSendSignup = useSelector((state) => state.apiReducer.userSendSignup) || {};
const { response, error, loading } = userSendSignup || {};


  // ✅ RESPONSE WATCH (like your code)
  useEffect(() => {
    if (userSendSignup?.response?.data?.message) {
      console.log("OTP sent success");

      // 🔥 redirect
      navigate("/user/verify-otp", {
        state: { email, name, number },
      });
    }
  }, [userSendSignup]);

  // ✅ FIX: API CALL YAHAN KARO
  const handleSignup = (e) => {

     if (!email || !name || !number) {
      alert("Please enter email, name, and phone number");
      return;
    }

    if (!/^\d{10}$/.test(number)) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    e.preventDefault();

    dispatch(
      httpRequest({
        key: API_END_POINTS.userSendSignup.KEY,
        data: {
          name,
          email,
          number,
        },

        onSuccess: (res) => {
          console.log("OTP Sent:", res);
          toast.success("OTP Sent Successfully 🚀");
          navigate("user/verify-otp", { state: { email, name, number } });
        },

        onError: (err) => {
          console.log("Error:", err);
          toast.error(err?.message || "Failed to send OTP. Please try again.");
        },
      })
    );
  };

  // console.log("Signup State:", { name, email, number });
  // console.log("API State:", { loading, error, response });
  return (
    <div className="login-page-wrapper d-flex justify-content-center align-items-center min-vh-100 px-3">

      <div className="ocean">
        <div className="bubbles"></div>
        <div className="moving-bottle b1"></div>
        <div className="moving-bottle b2"></div>
        <div className="moving-bottle b3"></div>
      </div>

      <div className="glass-overlay"></div>

      <div className="col-12 col-sm-10 col-md-8 col-lg-4 z-index-master my-2">

        <form className="login-card shadow-lg p-3" onSubmit={handleSignup}>

          <div className="logo-wrapper mb-2 text-center">
            <img
              src={logo}
              alt="Rankers"
              className="login-logo shadow"
            />
          </div>

          <div className="text-center mb-3">
            <h5 className="fw-bold text-white mb-1">Create Account</h5>
            <p className="text-white-50 small mb-0">Join Rankers today</p>
          </div>

  {error && (
        <p style={{ color: "red" }}>
          {typeof error === "string" ? error : error?.message}
        </p>
      )}
          {/* NAME */}
          <div className="input-group-custom mb-2">
            <label className="small fw-bold text-white-50">Full Name</label>
            <input
              type="text"
              className="form-control login-input py-2"
              placeholder="Enter your full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* EMAIL */}
          <div className="input-group-custom mb-3">
            <label className="small fw-bold text-white-50">Email Address</label>
            <input
              type="email"
              className="form-control login-input py-2"
              placeholder="user@rankers.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* PHONE NUMBER */}
          <div className="input-group-custom mb-3">
            <label className="small fw-bold text-white-50">Phone Number</label>
            <input
              type="tel"
              className="form-control login-input py-2"
              placeholder="10-digit phone number"
              value={number}
              onChange={(e) => setNumber(e.target.value.replace(/\D/g, ''))}
              maxLength="10"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-login-primary w-100 py-2 shadow"
            disabled={loading}
          >
            {loading ? (
              <Loader />
            ) : (
              "Send OTP"
            )}
          </button>

          <p className="signup text-center mt-3 mb-0 text-white-50 small">
            Already have an account? <Link to="/user/login">Login</Link>
          </p>

        </form>
      </div>
    </div>
  );
}

export default Signup;